/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Resume_Perf_DescInputs */

const en_analytics_resume_perf_desc = /** @type {(inputs: Analytics_Resume_Perf_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See which resumes perform best across your applications.`)
};

const de_analytics_resume_perf_desc = /** @type {(inputs: Analytics_Resume_Perf_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieh, welche Lebensläufe bei deinen Bewerbungen am besten abschneiden.`)
};

const fr_analytics_resume_perf_desc = /** @type {(inputs: Analytics_Resume_Perf_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvre quels CV obtiennent les meilleurs résultats dans tes candidatures.`)
};

const es_analytics_resume_perf_desc = /** @type {(inputs: Analytics_Resume_Perf_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vea qué currículums obtienen mejores resultados en sus solicitudes.`)
};

const it_analytics_resume_perf_desc = /** @type {(inputs: Analytics_Resume_Perf_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri quali curriculum funzionano meglio nelle tue candidature.`)
};

const nl_analytics_resume_perf_desc = /** @type {(inputs: Analytics_Resume_Perf_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk welke CV's het beste presteren in je sollicitaties.`)
};

const pl_analytics_resume_perf_desc = /** @type {(inputs: Analytics_Resume_Perf_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdź, które CV najlepiej sprawdzają się w Twoich aplikacjach.`)
};

const fi_analytics_resume_perf_desc = /** @type {(inputs: Analytics_Resume_Perf_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katso, mitkä ansioluettelot toimivat parhaiten hakemuksissasi.`)
};

const da_analytics_resume_perf_desc = /** @type {(inputs: Analytics_Resume_Perf_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se, hvilke CV'er der performer bedst i dine ansøgninger.`)
};

const sv_analytics_resume_perf_desc = /** @type {(inputs: Analytics_Resume_Perf_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se vilka CV:n som presterar bäst i dina ansökningar.`)
};

/**
* | output |
* | --- |
* | "See which resumes perform best across your applications." |
*
* @param {Analytics_Resume_Perf_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_resume_perf_desc = /** @type {((inputs?: Analytics_Resume_Perf_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Resume_Perf_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_resume_perf_desc(inputs)
	if (locale === "fr") return fr_analytics_resume_perf_desc(inputs)
	if (locale === "es") return es_analytics_resume_perf_desc(inputs)
	if (locale === "it") return it_analytics_resume_perf_desc(inputs)
	if (locale === "nl") return nl_analytics_resume_perf_desc(inputs)
	if (locale === "pl") return pl_analytics_resume_perf_desc(inputs)
	if (locale === "fi") return fi_analytics_resume_perf_desc(inputs)
	if (locale === "da") return da_analytics_resume_perf_desc(inputs)
	if (locale === "sv") return sv_analytics_resume_perf_desc(inputs)
	return en_analytics_resume_perf_desc(inputs)
});